// src/components/Header.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_HEADER = {
  width: "100%",
  backgroundColor: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
  borderBottom: "1px solid #f0f0f0",
};

const styles = {
  desktopHeader: {
    ...BASE_HEADER,
    height: "84px",
    padding: "0 120px",
  },
  mobileHeader: {
    ...BASE_HEADER,
    height: "64px",
    padding: "0 16px",
  },
  brand: {
    color: "#5c5470",
    fontSize: "36px",
    fontWeight: 800,
    lineHeight: "54px",
    cursor: "pointer",
  },
  mobileBrand: {
    color: "#5c5470",
    fontSize: "22px",
    fontWeight: 800,
    lineHeight: "32px",
    cursor: "pointer",
  },
  nav: {
    display: "flex",
    gap: "28px",
  },
  navItem: {
    color: "#6b7280",
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "31px",
    cursor: "pointer",
  },
};

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      if (typeof window === "undefined") return;
      setIsMobile(window.innerWidth <= breakpoint);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
}

export default function Header() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // DESKTOP / TABLET HEADER
  if (!isMobile) {
    return (
      <div style={styles.desktopHeader}>
        {/* Left: Brand → Home */}
        <div style={styles.brand} onClick={() => navigate("/")}>
          613Nail Hub
        </div>

        {/* Right: Navigation */}
        <div style={styles.nav}>
          <div style={styles.navItem} onClick={() => navigate("/about")}>
            About Us
          </div>
          <div style={styles.navItem} onClick={() => navigate("/booking")}>
            Booking
          </div>
        </div>
      </div>
    );
  }

  // MOBILE HEADER (logo + burger + side drawer)
  return (
    <>
      <header style={styles.mobileHeader}>
        <div
          style={styles.mobileBrand}
          onClick={() => {
            setMobileMenuOpen(false);
            navigate("/");
          }}
        >
          613Nail Hub
        </div>

        <button
          onClick={() => setMobileMenuOpen((v) => !v)}
          style={{
            width: 32,
            height: 32,
            borderRadius: 999,
            border: "none",
            background: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            gap: 4,
            cursor: "pointer",
          }}
          aria-label="Open navigation menu"
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: 20,
                height: 2,
                borderRadius: 999,
                backgroundColor: "#5c5470",
                transition: "transform 0.2s ease, opacity 0.2s ease",
              }}
            />
          ))}
        </button>
      </header>

      {mobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setMobileMenuOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.35)",
              zIndex: 40,
            }}
          />

          {/* Drawer */}
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              height: "100vh",
              width: 260,
              backgroundColor: "#f7f5f2",
              boxShadow: "-4px 0 12px rgba(0,0,0,0.15)",
              zIndex: 41,
              padding: "20px 16px",
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
              }}
            >
              <span style={{ ...styles.mobileBrand, cursor: "default", fontSize: 20 }}>
               
              </span>
              <button
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 22,
                  lineHeight: 1,
                  cursor: "pointer",
                  color: "#5c5470",
                }}
              >
                ×
              </button>
            </div>

            <button
              onClick={() => {
                setMobileMenuOpen(false);
                navigate("/booking");
              }}
              style={{
                border: "none",
                background: "transparent",
                padding: "8px 0",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              <span style={{ ...styles.navItem, fontSize: 16 }}>Booking</span>
            </button>

            <button
              onClick={() => {
                setMobileMenuOpen(false);
                navigate("/about");
              }}
              style={{
                border: "none",
                background: "transparent",
                padding: "8px 0",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              <span style={{ ...styles.navItem, fontSize: 16 }}>About Us</span>
            </button>
          </div>
        </>
      )}
    </>
  );
}
